import Header from '../../../shared/Header';
import {Box, Cluster, Stack} from '../../../shared/layouts';
import RemoveIcon from 'imagesUwKluis/svg/close.svg';

const FormList = ({onDelete, ...props}) => {
    const allowDeleteButtonRender = () => {
        if (props.index === 0) {
            return false;
        }

        if (props?.allowToDeleteOnlyLastElement ) {
            return props.isLastElement;
        }

        return true;
    }
    return (
        <Box mb={'l'}>
            <Header
                variant="section"
                mb={'l'}
                title={
                    <Cluster hGap="l">
                        <Box css={{'&:first-letter': {textTransform: 'capitalize'}}}>
                            {`${props?.item} ${props?.index + 1}`}
                        </Box>
                        {allowDeleteButtonRender() && (
                            <RemoveIcon
                                css={(theme) => ({
                                    fill: theme?.colors?.alert || 'red',
                                    cursor: 'pointer',
                                    margin: '4px',
                                    width: '32px',
                                    height: '32px',
                                })}
                                onClick={onDelete}
                            />
                        )}
                    </Cluster>
                }
            />
            <Stack space={'m'} {...props} />
        </Box>
    )
}

export default FormList;
